import React, { useState } from 'react';
import {
  Map, TileLayer, FeatureGroup, Marker as LeafletMarker,
} from 'react-leaflet';
import { Button } from '@material-ui/core';
import Control from 'react-leaflet-control';
import L from 'leaflet';
import { EditControl } from 'react-leaflet-draw';
import SearchPanel from './SearchPanel';
import 'leaflet-draw/dist/leaflet.draw.css';

export const Marker = LeafletMarker;
// const __DEV__ = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

export default (props) => {
  let editableFG;
  const [center, set_center] = useState([4.559534, 109.901625]);
  const [markers, set_markers] = useState([]);
  const [zoom, set_zoom] = useState(6);
  // const viewport = { center, zoom };
  // const Leaflet = window.L;
  // const max_bounds = Leaflet.latLngBounds([[7.410776, 90.628988], [0.83482, 119.26909]]);
  // const [bounds, set_bounds] = useState(max_bounds);

  const hasEdit = !!props.onConfirmDraw;

  const changeFocus = (gps, zoom_level = 15) => {
    set_center(gps);
    set_zoom(zoom_level);
  };

  // useEffect(() => {
  //   if (props.draw_data?.features.length) {
  //     set_bounds(new L.GeoJSON(props.draw_data).getBounds());
  //   }
  // }, [props.draw_data]);

  const onFeatureGroupReady = (c) => {
    if (!c) return;

    if (props.draw_data) {
      const leafletGeoJSON = new L.GeoJSON(props.draw_data);
      leafletGeoJSON.eachLayer((layer) => c.leafletElement.addLayer(layer));
    }

    editableFG = c;
  };

  const confirm = () => {
    let data;
    if (props.is_draw) {
      data = editableFG.leafletElement.toGeoJSON();
    } else if (props.is_select_coordinate) {
      if (markers.length) {
        data = { lat: markers[0][0].toFixed(6), lng: markers[0][1].toFixed(6) };
      }
    }
    props.onConfirmDraw(data);
  };

  return (
    <Map
      onClick={e => {
        if (props.is_select_coordinate) {
          set_markers([[e.latlng.lat, e.latlng.lng]]);
        }
        if (props.onClick) props.onClick();
      }}
      animate
      // zoomControl={false}
      center={center}
      zoom={zoom}
      // doubleClickZoom={false}
      // minZoom={__DEV__ ? undefined : zoom}
      // viewport={props.viewport || viewport}
      // bounds={bounds}
      // maxBounds={__DEV__ ? undefined : max_bounds}
      className="w-100 h-100"
    >
      <TileLayer
        attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        url="https://api.maptiler.com/maps/streets/{z}/{x}/{y}.png?key=YRtSyaztOM3LGN1gVGCK"
      // url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <FeatureGroup ref={(reactFGref) => onFeatureGroupReady(reactFGref)}>
        {props.is_draw && (
          <EditControl
            position="topright"
            draw={{
              circlemarker: false, polyline: false, circle: false, rectangle: false,
            }}
          />
        )}
      </FeatureGroup>
      {hasEdit && (
        <Control position="bottomright">
          <div className="row align-items-end space-children-horizontal mr-2">
            <SearchPanel changeFocus={changeFocus} />
            <Button
              size="small"
              className="background-secondary"
              variant="contained"
              onClick={confirm}
              children="Set"
            />
          </div>
        </Control>
      )}
      {props.children}
      {markers?.map(p => <LeafletMarker position={p} />)}
    </Map>
  );
};
